import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
// import Mainlayout from "./components/Layouts/Mainlayout";
import Sidebarcontext from "./context/Sidebarcontext";
import PopupContext from "./context/Popupscontext";
import Authlayout from "./components/Layouts/Authlayout";
import LiveIR from "./components/LiveEvents/LiveIR"; // ✅ Add this
import ProtectedRoutes from "./ProtectedRoutes/ProtectedRoutes";
import Filtercontext from "./context/Filtercontext";
import { ToastContainer } from "react-toastify";
import Soon from "./components/Soon";
import Draggablecontext from "./context/Draggablecontext";
import ExportDataContext from "./context/ExportDataContext";
import DashboardContext from "./context/DashboardContext";
import LanguageContext from "./context/LanguageContext";
import AdaptiveLayout from "./components/Layouts/AdaptiveLayout";
import { useEffect, useState } from "react";
import { isRTL } from "./utils";
import { ConfigProvider } from "antd";

// import TaskBuilder from "./components/TaskBuilder/TaskBuilder";

import { Routes } from "./utils/Routing/routing";
import DownloadOnMobile from "./components/DownloadOnMobile";
import LiveSnag from "./components/LiveEvents/LiveSnag"; // Add this import
import LiveTrackingContenxt from "./context/LiveTrackingContext";
import AuthLogin from "./components/Login/AuthLogin";

import L from "leaflet";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./components/TermsAndConditions/PrivacyPolicy";
import AboutUs from "./components/TermsAndConditions/AboutUs";
import DeleteAccount from "./components/Delete Account/DeleteAccount";
import ApiDocs from "./components/ApiDocs/ApiDocs";
import Offline from "./components/Offline";
import { checkServiceWorkerCache } from "./utils/checkServiceWorkerCache";
function App() {
  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
  });
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      window.location.reload();
    };
    const handleOffline = () => setIsOnline(false);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      checkServiceWorkerCache();
    }, 2000);
  }, []);

  let routes = createBrowserRouter(
    [
      {
        path: "/",
        element: (
          <ProtectedRoutes>
            <AdaptiveLayout />
          </ProtectedRoutes>
        ),
        children: Routes,
      },
      {
        path: "/",
        element: <Authlayout />,
        children: [{ path: "signin", element: <AuthLogin /> }],
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/privacy-policy/fsm",
        element: <PrivacyPolicy mode="fsm" />,
      },
      {
        path: "/privacy-policy/construction",
        element: <PrivacyPolicy mode="construction" />,
      },
      {
        path: "/privacy-policy/tracking",
        element: <PrivacyPolicy mode="tracking" />,
      },
      {
        path: "/privacy-policy/uma-client",
        element: <PrivacyPolicy mode="client" />,
      },
      {
        path: "/offline",
        element: <Offline />,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
      },
      {
        path: "/uma-uk-delete-account",
        element: <DeleteAccount />,
      },
      {
        path: "/api-docs/backend3",
        element: (
          <ApiDocs url={`${process.env.REACT_APP_BACKEND3_URL}/openapi.json`} />
        ),
      },
      {
        path: "/api-docs/MaintBackend",
        element: (
          <ApiDocs
            url={`${process.env.REACT_APP_BACKEND2_URL}/v1/openapi.json`}
          />
        ),
      },

      {
        path: "*",
        element: (
          <ProtectedRoutes>
            <Soon />
          </ProtectedRoutes>
        ),
      },
    ],
    { basename: process.env.REACT_APP_BASE || "/frontend2" },
  );
  return (
    <>
      {/* <Offline>
				<div
					style={{
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						fontSize: "24px",
						fontWeight: "bold",
					}}
				>
					No Internet Connection
				</div>
			</Offline> */}

      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#0f6936",
            activeBg: "#0f6936",
            activeBorderColor: "#2e9245",
            fontFamily: !isRTL ? "Poppins" : "Poppins",
          },
        }}
        direction={!isRTL ? "ltr" : "rtl"}
      >
        <LiveIR />
        <LiveSnag />
        <LanguageContext>
          <Sidebarcontext>
            <PopupContext>
              <Filtercontext>
                <Draggablecontext>
                  <ExportDataContext>
                    <DashboardContext>
                      <LiveTrackingContenxt>
                        <RouterProvider router={routes} />
                      </LiveTrackingContenxt>
                    </DashboardContext>
                  </ExportDataContext>
                </Draggablecontext>
              </Filtercontext>
            </PopupContext>
          </Sidebarcontext>
        </LanguageContext>
      </ConfigProvider>

      <ToastContainer
        theme="colored"
        position={isRTL ? "top-left" : "top-right"}
      />
    </>
  );
}

export default App;
